import type { SVGProps } from 'react';

/**
 * One star, drawn once per page and referenced wherever a rating is shown.
 *
 * lucide's `<Star>` inlines its 650-byte path for every star, and a product
 * page draws about forty-five of them (the review list, the rating bars, the
 * summary) — 30 KB of a 370 KB page, paid again on every render the CDN has
 * to fetch from a function. `<StarSprite>` mounts the path once in the root
 * layout; `<StarIcon>` is a `<use>` reference a tenth the size. It takes the
 * same `className` the lucide icon did: `fill-*` and `text-*` utilities set
 * the fill and the stroke.
 */
export const STAR_SYMBOL_ID = 'wm-star';
const STAR_PATH =
	'M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z';

export function StarSprite() {
	return (
		<svg width={0} height={0} className="absolute" aria-hidden="true" focusable="false">
			<symbol id={STAR_SYMBOL_ID} viewBox="0 0 24 24">
				<path d={STAR_PATH} />
			</symbol>
		</svg>
	);
}

export function StarIcon({ className, ...rest }: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			className={className}
			{...rest}
		>
			<use href={`#${STAR_SYMBOL_ID}`} />
		</svg>
	);
}
